import { render } from "./RemovedInventory.vue?vue&type=template&id=1076ae4e"
import script from "./RemovedInventory.vue?vue&type=script&lang=js"
export * from "./RemovedInventory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__